import { useAuth } from "@/context/AuthContext";

export default function WatermarkOverlay() {
  const { user } = useAuth();
  if (!user) return null;

  // Usa número de registro profissional ou email como identificador
  const identifier = user.council_number || user.email || user.user_id?.slice(0, 8);
  const line1 = user.full_name || user.name || "";
  const line2 = identifier ? `Reg: ${identifier}` : "";

  // Gera 40 itens para cobrir toda a tela em diagonal
  const items = Array.from({ length: 40 });

  return (
    <div
      className="fixed inset-0 z-[9997] pointer-events-none select-none overflow-hidden"
      aria-hidden="true"
      data-testid="watermark-overlay"
    >
      <div
        style={{
          position: "absolute",
          top: "-30%",
          left: "-20%",
          width: "140%",
          height: "160%",
          transform: "rotate(-22deg)",
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gridTemplateRows: "repeat(10, 1fr)",
          gap: 0,
        }}
      >
        {items.map((_, i) => (
          <div
            key={i}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              opacity: 0.04,
              padding: "8px",
            }}
          >
            <span style={{ fontSize: "11px", fontWeight: 600, color: "#1e293b", whiteSpace: "nowrap" }}>
              {line1}
            </span>
            {line2 && (
              <span style={{ fontSize: "10px", color: "#1e293b", whiteSpace: "nowrap", marginTop: "2px" }}>
                {line2}
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
